import { categories } from '@/mocks/categories';

export default function Hero() {
  return (
    <section className="relative min-h-screen flex flex-col overflow-hidden">
      <div
        className="absolute inset-0"
        style={{
          background: 'linear-gradient(135deg, oklch(0.98 0.004 86) 0%, oklch(0.94 0.02 60 / 0.6) 50%, oklch(0.92 0.03 320 / 0.3) 100%)',
        }}
      />
      <div className="absolute inset-0">
        <div
          className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] rounded-full opacity-[0.06]"
          style={{ background: 'radial-gradient(circle, oklch(0.6 0.18 28), transparent 70%)' }}
        />
        <div
          className="absolute bottom-[10%] left-[-5%] w-[400px] h-[400px] rounded-full opacity-[0.05]"
          style={{ background: 'radial-gradient(circle, oklch(0.62 0.11 152), transparent 70%)' }}
        />
      </div>

      <div className="relative z-10 flex flex-col flex-1 w-full max-w-7xl mx-auto px-4 md:px-6 pt-24 md:pt-32 pb-0">
        <div className="flex flex-col lg:flex-row items-start gap-8 lg:gap-16 flex-1 mt-8 md:mt-16">
          <div className="flex-1 w-full lg:w-[55%]">
            <h1 className="font-heading text-5xl md:text-7xl lg:text-8xl font-bold text-foreground-950 leading-[1.05] tracking-tight">
              CSSBuy<br />
              Spreadsheet<br />
              <span className="italic font-medium text-primary-500">Resource Hub</span>
            </h1>
          </div>

          <div className="flex-1 w-full lg:w-[45%] flex flex-col justify-center gap-8">
            <p className="text-base md:text-lg text-foreground-600 leading-relaxed max-w-md">
              Your independent resource center for <strong className="text-foreground-900">CSSBuy spreadsheet</strong> links, verified seller guides, and curated shopping categories. Discover the best CSSBuy sheet for every brand and category — updated weekly by real buyers in the community.
            </p>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-7 py-3 bg-foreground-950 text-background-50 rounded-full text-sm font-semibold hover:bg-foreground-800 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                CSSBuy Sheet
                <i className="ri-arrow-right-up-line"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-1 text-foreground-700 text-sm font-medium hover:text-foreground-950 transition-colors duration-200 border-b border-foreground-300 hover:border-foreground-700 pb-0.5 whitespace-nowrap cursor-pointer"
              >
                Buy It Now
                <i className="ri-arrow-right-line text-xs"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="relative z-10 w-full mt-12 md:mt-20">
        <div className="w-full h-[280px] md:h-[400px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Dynamic%20lifestyle%20arrangement%20of%20fashion%20sneakers%20oversized%20hoodie%20sunglasses%20designer%20bag%20and%20accessories%20scattered%20on%20light%20concrete%20floor%20with%20dramatic%20diagonal%20shadows%20from%20window%20blinds%20editorial%20street%20style%20photography%20with%20warm%20amber%20and%20cool%20slate%20contrast%20urban%20loft%20atmosphere%20with%20industrial%20textures%20high-end%20casual%20aesthetic%20modern%20composition&width=1800&height=800&seq=hero-collage-v3&orientation=landscape"
            alt="CSSBuy Spreadsheet Product Categories Collage"
            title="CSSBuy Spreadsheet Product Categories"
            className="w-full h-full object-cover object-top opacity-80"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-transparent to-transparent"></div>
      </div>
    </section>
  );
}